module.exports = __webpack_public_path__ + "static/media/Decoration_FarmCup.3fdbbd21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_FarmCup.png
// module id = 1347
// module chunks = 3